import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule, Location } from '@angular/common';
import { AfterViewInit, Component, inject, Input, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import {
  MatPaginatorModule,
  MatPaginator,
  PageEvent,
} from '@angular/material/paginator';

import { AlertService } from '../../core/services/alert/alert.service';
import { LocalStorageService } from '../../core/services/localStorage/local-storage.service';
import { Invoices } from '../../core/interfaces/invoices';
import { DocumentType, AccountData, ApiResponse } from '../../core/interfaces/common';
import { UsersService } from '../../core/services/users/users.service';
import { FormAddUsersComponent } from "./form-add-users/form-add-users.component";
import { AuthStateService } from '../../core/services/auth-state/auth-state-service.service';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    TranslateModule,
    NgSelectModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule, FormAddUsersComponent],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css'
})

export class UsersComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private route = inject(ActivatedRoute);
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  showForm = false;
  showAddUserForm = false;
  showClear = false;

  pageNumber: number = 1;
  pageSize: number = 25;
  sortColumn: string = 'name';
  sortDirection: string = 'asc';

  user_reference?: any;
  userData?: any;
  isSelfEdit = false;
  authenticatedUserReference: string | null = null;

  dataSource = new MatTableDataSource<Invoices>();
  title = 'users';

  showAlertFilter = false;
  showCountFilter = 0;
  showAlertFilterAll = false;
  searchParams: any = {};
  accountType: string | null = null;

  ladata: any = [];
  cargaladata: any = [];

  document_buttons_chico = false;
  tab = 'general';


  displayedColumns: string[] = [
    'name',
    'lastname',
    'roles',
    'phone',
    'email',
    'img',
    'status',
    'actions',
  ];

  type: any = 'broker';
  autoFetch: any;

  @Input() selectTypes: DocumentType[] = [];

  // Mapa para relacionar rutas con sus títulos y tipos de orden
  routesMap: { [key: string]: string } = {
    users: '',
    'users/all': '',
    'users/paid': 'paid',
    'users/drafts': 'drafts',
    'users/pending': 'pending',
    'users/delivered': 'delivered',
    'users/cancelled': 'cancelled',
  };

  constructor(
    private location: Location,
    private titleService: Title,
    private alertService: AlertService,
    private translate: TranslateService,
    private localStorageService: LocalStorageService,
    private usersService: UsersService,
    private authStateService: AuthStateService,
  ) {
    this.authenticatedUserReference = this.authStateService.getUserReference();
  }

  ngOnInit() {
    const storedPerPage = this.localStorageService.getItem('per_page');
    if (storedPerPage) {
      this.pageSize = Number(storedPerPage);
    }
    this.detectReference(),
      this.alertService.loading('swal_messages.please_wait');
    this.fetchAllData();
    this.startAutoFetch();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    this.sort.sortChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.sortColumn = this.sort.active;
      this.sortDirection = this.sort.direction || 'asc';
      this.pageNumber = 1;
      this.fetchData();
    });
  }

  startAutoFetch(): void {
    if (this.autoFetch) {
      clearInterval(this.autoFetch);
    }
    // this.autoFetch = setInterval(() => {
    //   this.refreshUserData();
    // }, 40000);
  }

  detectReference() {

    // Obtener el tipo de cuenta del localStorage
    this.getAccountTypeFromLocalStorage();

    // Obtener la URL actual
    const nuevaURL = this.location.path();



    // Obtener la referencia de la orden
    let paramReference = this.route.snapshot.paramMap.get('reference');
    if (paramReference) {
      this.user_reference = paramReference;
      const updatedURL = `/users/`;
      this.location.go(updatedURL);
      this.getUser(paramReference);
    }
  }

  private fetchAllData() {
    Promise.all([
      this.fetchData(),
    ]).then(() => {
      this.ladata = this.cargaladata;
      setTimeout(() => {
        this.alertService.close();
      }, 500);
    });
  }

  expandedRow: any = null;

  toggleRow(row: any): void {
    const selection = window.getSelection();
    if (selection && selection.toString().trim().length > 0) return;
    this.expandedRow = row;
  }

  fetchData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.alertService.loading('swal_messages.please_wait');
      let exclude_authenticated = false;
      this.usersService.getData(
        exclude_authenticated,
        this.pageNumber,
        this.pageSize,
        this.sortColumn,
        this.sortDirection
      ).subscribe({
        next: (data) => {
          this.dataSource.data = data.data;
          this.cargaladata.flag = true;
          this.paginator.length = data.meta.total;
          this.paginator.pageSize = this.pageSize;
          this.paginator.pageIndex = this.pageNumber - 1;
          this.alertService.close();
          setTimeout(() => {
            resolve();
          }, 500);
        },
        error: (error) => {
          this.alertService.error(error.error);
          reject(error);
        },
      });
    });
  }

  getUser(reference: string): void {
    this.alertService.loading('swal_messages.please_wait');
    const nuevaURL = this.location.path() + '/' + reference;
    this.location.go(nuevaURL);

    this.user_reference = reference;
    this.isSelfEdit = reference === this.authenticatedUserReference;

    this.usersService.searchUser(this.user_reference).subscribe({
      next: (data) => {
        this.userData = data.data;
        const userName = data.data?.name ? (data.data.name + ' ' + (data.data.lastname || '')).trim() : data.data?.reference;
        this.titleService.setTitle(
          this.translate.instant('titles-menu-pages.users') +
          ' - ' + userName + ' - DBM'
        );
        this.showForm = true;
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.error('swal_messages.order_not_found');
      },
    });
  }

  deleteUser(reference: string): void {
    this.alertService
      .confirmation(
        'swal_messages.warning_confirm',
        'swal_messages.deleting_user',
        'swal_messages.confirm'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.alertService.loading('swal_messages.deleting_user');
          let formData = { status: 0 };

          this.usersService.updateData(formData, reference).subscribe(
            (response) => {
              this.fetchData();
              this.alertService.successOk('swal_messages.user_deleted');
            },
            (error) => {
              this.alertService.error(error.error);
            }
          );
        }
      });



  }

  toggleForm() {
    this.showForm = !this.showForm;
  }

  getAccountTypeFromLocalStorage(): void {
    this.accountType = localStorage.getItem('account_type');
  }

  cerrarFormulario() {
    this.titleService.setTitle(
      this.translate.instant('titles-menu-pages.users') + ' - DBM'
    );
    const nuevaURL = this.location.path() + '/users/';
    const index = nuevaURL.indexOf('/');
    this.location.go(
      nuevaURL.substring(0, index) + '/users/');
    this.userData = null;
    this.showForm = false;
    this.showAddUserForm = false;
    this.document_buttons_chico = false;
  }

  refrescar() {
    this.fetchData();
  }

  onPageChange(event: PageEvent): void {
    this.pageNumber = event.pageIndex + 1;
    this.localStorageService.setItem('per_page', String(event.pageSize));
    this.pageSize = event.pageSize;
    this.fetchData();
  }

  getBadgeColor(
    stage: string,
    require_action: string,
    priority: string
  ): string {
    const statusColorMap: { [key: string]: string } = {
      true: 'text-no-action',
      false: 'text-canceled',
    };


    // Default color if none of the conditions match
    return statusColorMap[stage] ? statusColorMap[stage] : 'text-no-action';
  }

  getBadgeColorClient(status: string): string {
    const statusColorMap: { [key: string]: string } = {
      organization: 'text-organization',
      'self-employed': 'text-self-employed',
      individual: 'text-individual',
    };

    return statusColorMap[status] || 'text-individual';
  }

  refreshUser() { }



  cerrarUserFormulario() {
    this.document_buttons_chico = false;
    this.showAddUserForm = false;
  }

  OpenFormAddUsers() {
    this.showAddUserForm = true;
    this.document_buttons_chico = true;
  }

  CloseFormAddUsers() {
    this.document_buttons_chico = false;
    this.showAddUserForm = false;
  }
}
